export default __webpack_public_path__ + "static/media/0x22e3f02f86bc8ea0d73718a2ae8851854e62adc5.c41b9fdb.webp";